module.exports = __webpack_public_path__ + "img/omelette-blanc-on.c798b879.svg";